import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11d22cdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Search_Contents" }
const _hoisted_2 = { class: "Search_Contents_Title" }
const _hoisted_3 = { class: "Search_Contents_List" }
const _hoisted_4 = ["checked"]

import { ref, watch } from "vue";

// props
interface Props {
  // css調整用----------
  titleMinWidth?: string;
  titleMaxWidth?: string;
  listMinWidth?: string;
  inputMinWidth?: string;
  // -------------------
  initialData: boolean; // 初期値
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'searchInputCheckbox',
  props: {
    titleMinWidth: {},
    titleMaxWidth: {},
    listMinWidth: {},
    inputMinWidth: {},
    initialData: { type: Boolean },
    title: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "4acdb2dc": (props.titleMaxWidth !== undefined?props.titleMaxWidth : '90px'),
  "12f9c824": (props.titleMinWidth !== undefined?props.titleMinWidth : '90px'),
  "81df0cb6": (props.listMinWidth !== undefined?props.listMinWidth : '224px'),
  "0a187fc7": (props.inputMinWidth !== undefined?props.inputMinWidth: 'initial')
}))

const props = __props;
// emit
const emit = __emit;

const inputValue = ref(false);
// 初期値の格納
watch(
  () => props.initialData,
  () => {
    if (props.initialData !== undefined) {
      inputValue.value = props.initialData;
    }
  },
  { immediate: true, deep: true }
);
const chengeInput = (e: Event) => {
  if (!(e.target instanceof HTMLInputElement)) throw new TypeError();
  inputValue.value = e.target.checked;
  emit("change", inputValue.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        type: "checkbox",
        onChange: chengeInput,
        checked: inputValue.value,
        class: _normalizeClass(["InputText_Checkbox", { Input_MinWidth: props.inputMinWidth !== undefined }])
      }, null, 42, _hoisted_4)
    ])
  ]))
}
}

})